import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import Github from "./Github";
import Techstack from "./Techstack";
import Aboutcard from "./AboutCard";
import laptopImg from "../../Assets/academic.png";
import Toolstack from "./Toolstack";
import career from "../../Assets/career.png";
import ghp from "../../Assets/ghp.png";

function About() {
  return (
    <Container fluid className="about-section">
      <Particle />
      <Container>
        <Row style={{ justifyContent: "center", padding: "10px" }}>
          <Col
            md={7}
            style={{
              justifyContent: "center",
              paddingTop: "30px",
              paddingBottom: "50px",
            }}
          >
            <h1 style={{ fontSize: "2.1em", paddingBottom: "20px" }}>
              <strong className="purple">Academic Goals</strong>
            </h1>
                                     <p style={{ textAlign: "justify", fontSize: "20px"}}>
I aim to pursue further study in computer science after high school, <b/>
beginning with a strong undergraduate program that will allow me <b/>
to develop a deeper and more comprehensive understanding of the field. <b/>
In college, I plan to major in computer science, where I can strengthen <b/>
my skills in programming, algorithms, and systems while also exploring <b/>
areas such as artificial intelligence and human-computer interaction. <b/>
After completing my undergraduate studies, I hope to continue into graduate<b/>
 school and eventually earn a PhD, focusing on advanced research that expands <b/>
 the possibilities of technology. By combining both theoretical knowledge<b/>
  and hands-on experience, I want to prepare myself for a career that blends <b/>
  research, innovation, and application.<b/>
                                              </p>
          </Col>
          <Col
            md={5}
            style={{ paddingTop: "120px", paddingBottom: "50px" }}
            className="about-img"
          >
            <img src={laptopImg} alt="about" className="img-fluid" />
          </Col>
        </Row>





      </Container>

       <Container>
              <Row style={{ justifyContent: "center", padding: "10px" }}>
                <Col
                  md={7}
                  style={{
                    justifyContent: "center",
                    paddingTop: "30px",
                    paddingBottom: "50px",
                  }}
                >
                  <h1 style={{ fontSize: "2.1em", paddingBottom: "20px" }}>
                    <strong className="purple">Career Goals</strong>
                  </h1>
                                           <p style={{ textAlign: "justify", fontSize:"20px" }}>
                                                      I am passionate about pursuing a career in game development and artificial intelligence, <b/>
                                                       where I can bring together creativity, problem-solving, and technical expertise<b/>
                                                        to design innovative experiences. In game development, my goal is to create projects <b/>
                                                        that are not only entertaining but also meaningful, using storytelling and interactivity<b/>
                                                         to engage players in new ways. At the same time, I am deeply interested in the<b/>
                                                          possibilities of AI, both as a tool to enhance games and as a broader field that pushes<b/>
                                                           the boundaries of how technology interacts with the world. By combining these two areas, <b/>
                                                           I hope to contribute to the future of technology and develop applications that are both<b/>
                                                            impactful and inspiring.<b/>
                                                    </p>
                </Col>
                <Col
                  md={5}
                  style={{ paddingTop: "120px", paddingBottom: "50px" }}
                  className="about-img"
                >
                  <img src={career} alt="about" className="img-fluid" />
                </Col>
              </Row>





            </Container>

             <Container>
                    <Row style={{ justifyContent: "center", padding: "10px" }}>
                      <Col
                        md={7}
                        style={{
                          justifyContent: "center",
                          paddingTop: "30px",
                          paddingBottom: "50px",
                        }}
                      >
                        <h1 style={{ fontSize: "2.1em", paddingBottom: "20px" }}>
                          <strong className="purple">GHP Goals</strong>
                        </h1>
                         <p style={{ textAlign: "justify", fontSize:"20px"}}>
                                    Through GHP, I hope to immerse myself in an environment that challenges me to think more critically, creatively, and independently. My goal is to use this program as an opportunity to not only build technical skills but also to collaborate with mentors and peers who share the same passion for computer science. I want to work on advanced, hands-on projects that allow me to explore new areas of the field and push beyond the boundaries of what I have previously learned. Most importantly, I hope GHP will help me grow as both a learner and a creator, preparing me to succeed in my academic journey and eventually in the professional world of computer science.
                                  </p>
                      </Col>
                      <Col
                        md={5}
                        style={{ paddingTop: "120px", paddingBottom: "50px" }}
                        className="about-img"
                      >
                        <img src={ghp} alt="about" className="img-fluid" />
                      </Col>
                    </Row>





                  </Container>
    </Container>
  );
}

export default About;
